/**
 * The joleu.ng split: one SPA build serves several hosts, each with its own
 * canonical home. These helpers keep navigation host-aware.
 *
 *   joleu.ng          — becoming the personal directory (CompOpus); the worker
 *                       keeps serving share surfaces (/r /i /f /vote …) here
 *   doopey.joleu.ng   — Doopey's World (the module library, canonical home)
 *   joluno.joleu.ng   — Jo Luno, served at clean paths (/ and /links)
 */
export const BASE_HOST = 'joleu.ng';
export const DOOPEY_HOST = 'doopey.joleu.ng';
export const JOLUNO_HOST = 'joluno.joleu.ng';

export const isJoLunoHost = (): boolean =>
  typeof window !== 'undefined' && window.location.hostname === JOLUNO_HOST;

export const isBaseHost = (): boolean =>
  typeof window !== 'undefined' && window.location.hostname === BASE_HOST;

/**
 * Origin for share links (/r /i /f /t /vote /scheduler …). Every production
 * host hands them out as short https://joleu.ng/… URLs, which joleu.ng keeps
 * resolving forever (share pages redirect people to their doopey home, which
 * also serves the same paths directly). Local dev and preview hosts keep their
 * own origin.
 */
export function shareOrigin(): string {
  if (typeof window === 'undefined') return `https://${BASE_HOST}`;
  const { hostname, origin } = window.location;
  const onEstate = hostname === BASE_HOST || hostname.endsWith(`.${BASE_HOST}`);
  return onEstate ? `https://${BASE_HOST}` : origin;
}

/**
 * Origin for links to a tool page with its settings (/tone?f=… /regex#…).
 * Only share surfaces are permanent on joleu.ng, so these point at the
 * module's canonical home, doopey.joleu.ng. Local dev and preview hosts
 * keep their own origin.
 */
export function toolOrigin(): string {
  if (typeof window === 'undefined') return `https://${DOOPEY_HOST}`;
  const { hostname, origin } = window.location;
  const onEstate = hostname === BASE_HOST || hostname.endsWith(`.${BASE_HOST}`);
  return onEstate ? `https://${DOOPEY_HOST}` : origin;
}

/** Path to a Jo Luno page, respecting the subdomain's clean URLs. */
export function joLunoPath(sub: '' | '/links'): string {
  return isJoLunoHost() ? (sub === '' ? '/' : sub) : `/joluno${sub}`;
}
